<template>
  <div>
    <div class="row">
      <div class="col-12 d-flex justify-content-end align-items-center">
        <span class="mr-1" style="color: #8800aa">
          <span class="badge" style="background: #8800aa; border-radius: 100px">
            R
          </span>
          Atendimento recorrente
        </span>
        <span class="mr-1" style="color: #aa5588">
          <span class="badge" style="background: #aa5588; border-radius: 100px">
            1º
          </span>
          Primeira recorrencia
        </span>
        <span>
          <toggle-button
            @change="showFinisheds"
            :labels="{ checked: 'Sim', unchecked: 'Não' }"
            :width="55"
            v-model="showFinished"
          />
          <span> Exibir finalizados </span>
        </span>
        <span>
          <toggle-button
            class="ml-1"
            @change="atualizarProgramacao"
            :labels="{ checked: 'Sim', unchecked: 'Não' }"
            :width="55"
          />
          <span> Atualizar Automaticamente </span>
        </span>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-md-2">
        <label>Número da Solicitação</label>
        <input
          type="text"
          class="form-control"
          v-model="filters.numero_solicitacao"
        />
      </div>
      <div class="col-md-2">
        <label>Data da Solicitação</label>
        <input
          type="date"
          class="form-control"
          v-model="filters.data_solicitacao"
        />
      </div>
      <div class="col-md-2">
        <label>Data do Transporte</label>
        <input
          type="date"
          class="form-control"
          v-model="filters.data_procedimento"
        />
      </div>
      <div class="col-md-3">
        <label>Tipo</label>
        <v-select
          :options="tipos_transporte"
          label="tipo_transporte_nome"
          v-model="filters.tipo_transporte_id"
          :reduce="(tipo) => tipo.tipo_transporte_id"
        ></v-select>
      </div>
      <div class="col-md-3">
        <label>Motivo</label>
        <v-select
          :options="motivo_transporte"
          label="motivo_transporte_nome"
          v-model="filters.motivo_transporte_id"
          :reduce="(motivo) => motivo.motivo_transporte_id"
        ></v-select>
      </div>
      <div class="col-md-3">
        <label>Nome do Paciente</label>
        <input
          type="text"
          class="form-control"
          v-model="filters.nome_paciente"
        />
      </div>
      <div class="col-md-4 mt-1">
        <label>Veículo</label>
        <input
          type="text"
          class="form-control"
          v-model="filters.nome_veiculo"
        />
      </div>
      <div class="col-md-4 mt-1">
        <label>Origem</label>
        <input type="text" class="form-control" v-model="filters.origem" />
      </div>
      <div class="col-md-4 mt-1">
        <label>Destino</label>
        <input type="text" class="form-control" v-model="filters.destino" />
      </div>
      <div class="col-md-3 mt-1">
        <label>Status</label>
        <select class="form-control" v-model="filters.status_solicitacao">
          <option value=""></option>
          <option value="1">Aguardando</option>
          <option value="2">Despachado</option>
        </select>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-md-2">
        <button class="btn btn-primary" @click="getSolitacoes">Filtrar</button>
      </div>
      <div class="col-md-2">
        <button class="btn btn-success" @click="limparFiltros">
          Limpar filtros
        </button>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-md-12">
        <div class="card content-crud">
          <div
            class="col-md-12 mt-1 text-right"
            v-if="$store.state.user.perfil_id != 22"
          >
            <button class="btn btn-primary" @click="add">
              Nova Solicitação
            </button>
          </div>
          <div class="ibox">
            <div class="ibox-title" style="padding: 16px">
              <h3>Solicitações</h3>
            </div>
            <div class="ibox-content">
              <div class="table-responsive" style="padding: 10px">
                <table
                  class="VueTables__table table table-striped table-bordered table-hover"
                  style="padding: 10px"
                >
                  <thead>
                    <tr>
                      <th scope="col">NÚMERO SOLICITACAO</th>
                      <th scope="col">DATA DA SOLICITAÇÃO</th>
                      <th scope="col">DATA DO TRANSPORTE</th>
                      <th scope="col">TIPO</th>
                      <th scope="col">MOTIVO</th>
                      <th scope="col">NOME PACIENTE</th>
                      <th scope="col">UNIDADE SOLICITANTE</th>
                      <th scope="col">STATUS</th>
                      <th scope="col">AÇÕES</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="solicitacao in solicitacoes"
                      :key="solicitacao.numero_solicitacao"
                    >
                      <td>{{ solicitacao.numero_solicitacao }}</td>
                      <td>{{ solicitacao.data_solicitacao_f }}</td>
                      <td>{{ solicitacao.data_procedimento_f }}</td>
                      <td>
                        {{
                          solicitacao.tipo_transporte
                            ? solicitacao.tipo_transporte.tipo_transporte_nome
                            : "Não informado"
                        }}
                      </td>
                      <td>
                        {{
                          solicitacao.motivo_transporte
                            ? solicitacao.motivo_transporte
                                .motivo_transporte_nome
                            : "Não informado"
                        }}
                      </td>
                      <td>
                        {{
                          solicitacao.paciente
                            ? solicitacao.paciente.nome_paciente
                            : "Não informado"
                        }}
                      </td>
                      <td>
                        {{
                          solicitacao.solicitante.unidade
                            ? solicitacao.solicitante.unidade.unidade_saude_nome
                            : "Não informado"
                        }}
                      </td>
                      <td v-html="status_solicitacao(solicitacao)"></td>
                      <td style="padding: 2px">
                        <router-link
                          v-if="$store.state.user.perfil_id != 22"
                          :to="'/programacoes/programacao/' + solicitacao.id"
                          title="Aprovar"
                          class="btn btn-crud edit ml-1"
                        >
                          <i class="fas fa-check"></i>
                        </router-link>
                        <router-link
                          v-if="
                            $store.state.user.perfil_id == 2 ||
                            $store.state.user.perfil_id == 6 ||
                            $store.state.user.perfil_id == 21
                          "
                          :to="'/solicitacoes/edit/' + solicitacao.id"
                          title="Editar"
                          class="btn btn-crud delete ml-1"
                        >
                          <i class="fas fa-edit"></i>
                        </router-link>
                        <router-link
                          v-if="$store.state.user.perfil_id == 22"
                          :to="'/solicitacoes/view/' + solicitacao.id"
                          title="Visualizar"
                          class="btn btn-crud view ml-1"
                        >
                          <i class="fas fa-eye"></i>
                        </router-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div
                  class="col-md-6 mt-1 mx-auto d-flex justify-content-center align-items-center"
                >
                  <pagination
                    :records="total"
                    :options="options"
                    :per-page="15"
                    @paginate="getSolitacoes"
                  ></pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../../layouts/Base/BaseCrud";
import vSelect from "vue-select";
import { Pagination } from "vue-pagination-2";
export default {
  data: function () {
    return {
      options: {
        texts: {
          count: "Mostrando {from} de {to} até {count} de registros",
        },
        chunk: 4,
        chunksNavigation: "fixed",
      },
      total: 0,
      page: 1,
      autoRefreshAtivado: false,
      pages: [],
      solicitacoes: [],
      showFinished: false,
      filters: {
        numero_solicitacao: "",
        data_solicitacao: "",
        data_procedimento: "",
        tipo_transporte_id: "",
        nome_paciente: "",
        nome_veiculo: "",
        origem: "",
        destino: "",
        status_solicitacao: "",
        motivo_transporte_id: "",
      },
      tipos_transporte: [],
      motivo_transporte: [],
    };
  },
  components: {
    BaseCrud,
    vSelect,
    Pagination,
  },

  methods: {
    getSolitacoes(page) {
      const self = this;

      self.page = page || 1;

      let api =
        self.$store.state.api + "solicitacoes/solicitados?page=" + self.page;

      self.$loading(true);
      axios
        .post(api, self.filters)
        .then((response) => {
          self.solicitacoes = response.data.data;
          self.total = response.data.total;
          self.$loading(false);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
          self.$loading(false);
        });
    },
    limparFiltros() {
      for (let key in this.filters) {
        this.filters[key] = "";
      }
      this.getSolitacoes();
    },
    status_solicitacao: function (row) {
      if (row.status_solicitacao == 0) {
        return "<h5><span class='badge badge-warning'>Solicitado</span></h5>";
      }
      if (row.status_solicitacao == 1) {
        return "<h5><span class='badge badge-info'>Em atendimento</span></h5>";
      }
      if (row.status_solicitacao == 2) {
        return "<h5><span class='badge badge-primary'>Despachado</span></h5>";
      }
      if (row.status_solicitacao == 3) {
        return "<h5><span class='badge badge-success'>Finalizado</span></h5>";
      }
      if (row.status_solicitacao == 4) {
        return "<h5><span class='badge badge-danger'>Cancelado</span></h5>";
      }
      if (row.status_solicitacao == 5) {
        return "<h5><span class='badge badge-secondary'>Retorno</span></h5>";
      }
      if (row.status_solicitacao == 6) {
        return "<h5><span class='badge badge-dark'>Sem Desfecho</span></h5>";
      }
      if (row.status_solicitacao == 7) {
        return "<h5><span class='badge' style='background: #17a2b8; color: white;'>Aguardando aprovação</span></h5>";
      }
    },
    retorno: function (row) {
      if (row.retorno == 1) {
        return "<h5><span class='badge badge-primary'>Sim</span></h5>";
      }
      if (row.retorno == 0) {
        return "<h5><span class='badge badge-secondary'>Não</span></h5>";
      }
    },
    getMotivos: function () {
      const self = this;
      let api =
        self.$store.state.api + "motivo_transporte?paginated=false&status=1";

      axios
        .get(api)
        .then((response) => {
          self.motivo_transporte = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getTipos: function () {
      const self = this;
      let api =
        self.$store.state.api + "tipo_transportes?paginated=false&status=1";

      axios
        .get(api)
        .then((response) => {
          self.tipos_transporte = response.data.data;

          if (self.tipos_transporte.length == 1) {
            self.entity.tipo_transporte_id =
              self.tipos_transporte[0].tipo_transporte_id;

            if (self.tipos_transporte[0].tipo_solicitacao == 0) {
              self.getMotivos();
              self.inverse = true;
              self.estilo_transporte = 0;
              self.page = 2;
              self.setPages();
            }
          }
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    atualizarProgramacao(valor) {
      this.autoRefreshAtivado = valor;
      if (valor) {
        this.iniciarTemporizadorAutoRefresh();
      } else {
        this.pararTemporizadorAutoRefresh();
      }
    },
    iniciarTemporizadorAutoRefresh() {
      if (this.autoRefreshAtivado) {
        this.temporizadorAutoRefresh = setInterval(() => {
          this.getProgramados();
        }, 10000);
      }
    },
    pararTemporizadorAutoRefresh() {
      clearInterval(this.temporizadorAutoRefresh);
    },
    filtered_dp(date) {
      this.data_procedimento = date;
    },
    filtered_ds(date) {
      this.data_solicitacao = date;
    },
    showFinisheds(res) {
      const self = this;
      self.$refs.programacaoCrud.$refs.table.refresh();
    },
    approving(props, row, index) {
      const self = this;
      this.$router.push("/aprovacoes/aprovacao/" + props.row.id);
    },
    add(props, row, index) {
      const self = this;
      this.$router.push("/solicitacoes/add");
    },
    playSound(volume) {
      var audio = new Audio(
        "https://soundbible.com/mp3/Air%20Plane%20Ding-SoundBible.com-496729130.mp3"
      );
      if (volume == null || volume == undefined) {
        volume = 0;
      }
      audio.volume = volume;
      audio.play();
    },
    iniciarEscutaWebSocket() {
      const self = this;

      console.log(
        "Iniciando escuta do canal 'solicitacoes' na tela de Solicitações..."
      );

      window.Echo.channel("solicitacoes")
        .listen(".nova-solicitacao", (e) => {
          // Tocar som de notificação
          self.playSound();

          // Número da solicitação com fallback - verificar estrutura do evento
          const numeroSolicitacao =
            e.numero_solicitacao ||
            (e.solicitacao && e.solicitacao.numero_solicitacao) ||
            e.solicitacao_id ||
            (e.solicitacao && e.solicitacao.transporte_sanitario_id) ||
            "N/A";

          // Exibir notificação visual
          if (e.tipo === "nova") {
            self.$message(
              "Nova Solicitação!",
              `Solicitação #${numeroSolicitacao} criada com sucesso!`,
              "success"
            );
          } else if (e.tipo === "atualizada") {
            self.$message(
              "Solicitação Atualizada!",
              `Solicitação #${numeroSolicitacao} foi atualizada!`,
              "info"
            );
          } else if (e.tipo === "cancelada") {
            self.$message(
              "Solicitação Cancelada!",
              `Solicitação #${numeroSolicitacao} foi cancelada!`,
              "warning"
            );
          }

          // Atualizar a lista automaticamente (apenas se estiver na mesma página)
          self.getSolitacoes(self.page);
        })
        .error((error) => {
          console.error("❌ Erro ao escutar o canal 'solicitacoes':", error);
        });

      console.log(
        "✅ Escuta do WebSocket configurada na tela de Solicitações!"
      );
    },
  },
  mounted() {
    const savedFilters = JSON.parse(localStorage.getItem("savedFilters"));
    if (savedFilters) {
      this.filters = savedFilters;
    }

    this.getSolitacoes();
    this.getTipos();
    this.getMotivos();

    // Iniciar escuta do WebSocket
    this.iniciarEscutaWebSocket();
  },
  watch: {
    filters: {
      handler(newFilters) {
        localStorage.setItem("savedFilters", JSON.stringify(newFilters));
      },
      deep: true,
    },
  },
  beforeDestroy() {
    // Desconectar do canal quando sair da página
    console.log(
      "Desconectando do canal 'solicitacoes' da tela de Solicitações..."
    );
    window.Echo.leave("solicitacoes");
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}

.uploading-image {
  display: flex;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}
</style>